export const TRADEABLE_PAIRS = [
    { symbol: 'BTCUSDT', label: 'BTC/USDT', fallbackPrice: 65948.64 },
    { symbol: 'ETHUSDT', label: 'ETH/USDT', fallbackPrice: 3472.18 },
    { symbol: 'SOLUSDT', label: 'SOL/USDT', fallbackPrice: 146.39 },
    { symbol: 'BNBUSDT', label: 'BNB/USDT', fallbackPrice: 585.12 },
    { symbol: 'XRPUSDT', label: 'XRP/USDT', fallbackPrice: 0.62157 },
    { symbol: 'DOGEUSDT', label: 'DOGE/USDT', fallbackPrice: 0.14721 },
    { symbol: 'ADAUSDT', label: 'ADA/USDT', fallbackPrice: 0.45852 },
    { symbol: 'LINKUSDT', label: 'LINK/USDT', fallbackPrice: 18.124 },
    { symbol: 'AVAXUSDT', label: 'AVAX/USDT', fallbackPrice: 39.281 },
    { symbol: 'LTCUSDT', label: 'LTC/USDT', fallbackPrice: 84.762 }
];
export function formatPairPrice(price) {
    if (!Number.isFinite(price)) {
        return '--';
    }
    if (price >= 1000) {
        return `$${price.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
    if (price >= 1) {
        return `$${price.toLocaleString('en-US', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
        })}`;
    }
    return `$${price.toLocaleString('en-US', {
        minimumFractionDigits: 5,
        maximumFractionDigits: 5
    })}`;
}
